// @K追加20250628　商品ページの数量指定ボックスにおいての上限値の制御 start
document.addEventListener('DOMContentLoaded', function () {
  console.log("🌕 MISEル custom.js が実行されました");

  // 🔹 必要な要素が揃うまで待機（最大試行あり）
  let tries = 0;
  const maxTries = 50; // 10秒（200ms × 50）
  const waitForElements = setInterval(() => {
    const quantityInput = document.getElementById('QuantityInput');
    const variantInput = document.querySelector('select[name="id"]');

    if (quantityInput && variantInput) {
      clearInterval(waitForElements);
      console.log("✅ 要素が見つかりました");

      let currentVariantId = variantInput.value;

      // 在庫に応じて max を更新する関数
      function updateMaxQuantity(variantId) {
        const variant = window.productData.variants.find(v => v.id == variantId);
        if (variant && variant.inventory_management === 'shopify') {
          quantityInput.max = variant.inventory_quantity;
          console.log("🔁 上限更新:", variantId, variant.inventory_quantity);

          // ＊＊＊数量が上限を超えていたら調整するstart＊＊＊
          
          const currentValue = parseInt(quantityInput.value, 10);
          // パターン①：在庫上限を超えていたら、上限値に切り下げる
          if (currentValue > variant.inventory_quantity) {
            quantityInput.value = variant.inventory_quantity;
          }
          // パターン②：常に「1」に戻す場合
          // quantityInput.value = 1;
          
          // ＊＊＊数量が上限を超えていたら調整するend＊＊＊
          
        } else {
          quantityInput.removeAttribute('max');
          console.warn("⚠️ max 属性を削除しました（在庫制御なし）");
        }
      }

      // 初期表示の在庫に基づいて更新
      updateMaxQuantity(currentVariantId);

      // バリアント切り替えの監視
      setInterval(() => {
        if (variantInput.value !== currentVariantId) {
          currentVariantId = variantInput.value;
          updateMaxQuantity(currentVariantId);
        }
      }, 300);

      // オプション（カラーやサイズ）選択にも対応
      document.querySelectorAll('[data-js-option-value]').forEach(el => {
        el.addEventListener('click', function () {
          setTimeout(() => {
            updateMaxQuantity(variantInput.value);
          }, 100);
        });
      });

    } else {
      tries++;
      console.log("⌛ 要素待機中...");

      if (tries > maxTries) {
        clearInterval(waitForElements);
        console.warn("⏰ 要素が見つからずタイムアウトしました");

        const fallbackInput = document.getElementById('QuantityInput');
        if (fallbackInput) {
          fallbackInput.removeAttribute('max');
          console.warn("⚠️ max 属性を削除しました（フェイルセーフ対応）");
        }
      }
    }
  }, 200);
});
// @K追加　商品ページの数量指定ボックスにおいての上限値の制御 end